import requests from "./httpService";

const HappyCustomerServices = {

    getHappy: async () =>{
        return requests.get(`/happycustomer`);
    },
    updateHappy : async (id,body) =>{
        console.log(body);
        return requests.patch(`/happycustomer/${id}`,body);
    },

    createHappy : async (body) =>{
        // console.log(body)
        return requests.post(`/happycustomer`,body);
    },
    deleteHappy : async (id) =>{
        return requests.delete(`/happycustomer/${id}`);
    },
    uploadVideo : async (body) =>{
        // console.log(body)
        return requests.post(`/happycustomer/uploadvideo`,body);
    },
  


}
export default HappyCustomerServices;